import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
// import { HorizonLogo } from "components/icons/Icons";
// import { BumpppyLogo } from "components/icons/Frame.png";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      {/* <BumpppyLogo h='26px' w='175px' my='32px' color={logoColor} /> */}
  <h3 style={{color:"rgb(22, 29, 111)"}}><b>Bumppy</b></h3>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
